// tabs/ShipBillTab.jsx - Ship/Bill tab
import React, { useState } from 'react';
import { Box, Grid, Stack, TextInput, Group, Text, NumberInput, Paper, Textarea } from '@mantine/core';

const ShipBillTab = ({ quoteData, setQuoteData }) => {
  const [shipBillData, setShipBillData] = useState({
    shipTo: {
      id: 0,
      contact: '',
      companyName: 'DELTA MATERIAL SERVICES (DMS)',
      address1: '3700 Southside Industrial Way SE',
      address2: '',
      address3: '',
      cityStateZip: 'Atlanta, GA 30354 UNITED STATES'
    },
    billTo: {
      id: 1,
      contact: 4,
      companyName: 'DELTA AIRLINES',
      address1: 'P.O. Box 830954',
      address2: '',
      address3: '',
      cityStateZip: 'Birmingham, AL 35283 UNITED STATES'
    }
  });

  const handleShipToChange = (field, value) => {
    setShipBillData(prev => ({
      ...prev,
      shipTo: { ...prev.shipTo, [field]: value }
    }));
  };

  const handleBillToChange = (field, value) => {
    setShipBillData(prev => ({
      ...prev,
      billTo: { ...prev.billTo, [field]: value }
    }));
  };

  return (
    <Box p="md">
      <Grid gutter="md">
        {/* Ship To Column */}
        <Grid.Col span={6}>
          <Paper withBorder p="md">
            <Group spacing="xs" align="flex-end" mb="md">
              <Text size="sm" fw={500} w={60}>Ship To:</Text>
              <NumberInput
                value={shipBillData.shipTo.id}
                variant="filled"
                size="sm"
                w={60}
                styles={{ input: { textAlign: 'center', fontWeight: 'bold', color: 'white', backgroundColor: 'blue' } }}
                onChange={(value) => handleShipToChange('id', value)}
              />
              <Text size="sm" fw={500} ml="md">Contact:</Text>
              <TextInput
                value={shipBillData.shipTo.contact}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => handleShipToChange('contact', e.target.value)}
              />
            </Group>

            <Stack spacing="xs">
              <TextInput
                value={shipBillData.shipTo.companyName}
                variant="filled"
                size="sm"
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleShipToChange('companyName', e.target.value)}
              />
              
              <TextInput
                value={shipBillData.shipTo.address1}
                variant="filled"
                size="sm"
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleShipToChange('address1', e.target.value)}
              />
              
              <TextInput
                value={shipBillData.shipTo.address2}
                variant="filled"
                size="sm"
                onChange={(e) => handleShipToChange('address2', e.target.value)}
              />
              
              <TextInput
                value={shipBillData.shipTo.address3}
                variant="filled"
                size="sm"
                onChange={(e) => handleShipToChange('address3', e.target.value)}
              />
              
              <TextInput
                value={shipBillData.shipTo.cityStateZip}
                variant="filled"
                size="sm"
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleShipToChange('cityStateZip', e.target.value)}
              />
            </Stack>
          </Paper>
        </Grid.Col>

        {/* Bill To Column */}
        <Grid.Col span={6}>
          <Paper withBorder p="md">
            <Group spacing="xs" align="flex-end" mb="md">
              <Text size="sm" fw={500} w={60}>Bill To:</Text>
              <NumberInput
                value={shipBillData.billTo.id}
                variant="filled"
                size="sm"
                w={60}
                styles={{ input: { textAlign: 'center', fontWeight: 'bold', color: 'blue' } }}
                onChange={(value) => handleBillToChange('id', value)}
              />
              <Text size="sm" fw={500} ml="md">Contact:</Text>
              <NumberInput
                value={shipBillData.billTo.contact}
                variant="filled"
                size="sm"
                w={60}
                styles={{ input: { textAlign: 'center', fontWeight: 'bold', color: 'blue' } }}
                onChange={(value) => handleBillToChange('contact', value)}
              />
            </Group>

            <Stack spacing="xs">
              <TextInput
                value={shipBillData.billTo.companyName}
                variant="filled"
                size="sm"
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleBillToChange('companyName', e.target.value)}
              />
              
              <TextInput
                value={shipBillData.billTo.address1}
                variant="filled"
                size="sm"
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleBillToChange('address1', e.target.value)}
              />
              
              <TextInput
                value={shipBillData.billTo.address2}
                variant="filled"
                size="sm"
                onChange={(e) => handleBillToChange('address2', e.target.value)}
              />
              
              <TextInput
                value={shipBillData.billTo.address3}
                variant="filled"
                size="sm"
                onChange={(e) => handleBillToChange('address3', e.target.value)}
              />
              
              <TextInput
                value={shipBillData.billTo.cityStateZip}
                variant="filled"
                size="sm"
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleBillToChange('cityStateZip', e.target.value)}
              />
            </Stack>
          </Paper>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default ShipBillTab;